import { IRoutingConfigVersion } from '@entities/routing/config-version';

// Publish (a draft goes live) and Activate (an archived version goes live again) are
// the same request and the same confirmation; only the words differ.
export type TPublishMode = 'publish' | 'activate';

export const getPublishMode = (version: IRoutingConfigVersion): TPublishMode =>
  version.status === 'archived' ? 'activate' : 'publish';

interface IPublishCopy {
  title: string;
  confirm: string;
  busy: string;
  blocked: string;
  rejected: string;
  // "v40 <done> — it is now the active version."
  done: string;
  // The "Goes live" row's hint, after the "N policies · M rules —" prefix.
  liveHint: string;
  // The same-config note: "<subject> has the same policies … — <verb> changes nothing".
  subject: string;
  verb: string;
}

export const PUBLISH_COPY: Record<TPublishMode, IPublishCopy> = {
  publish: {
    title: 'Publish',
    confirm: 'Publish',
    busy: 'Publishing…',
    blocked: 'Fix these before publishing:',
    rejected: 'Publishing was rejected:',
    done: 'published',
    liveHint: 'routes live orders right after publishing.',
    subject: 'This draft',
    verb: 'publishing',
  },
  activate: {
    title: 'Activate',
    confirm: 'Activate',
    busy: 'Activating…',
    blocked: 'Fix these before activating:',
    rejected: 'Activating was rejected:',
    done: 'activated',
    liveHint:
      'published again as-is, no draft in between — routes live orders right after activating.',
    subject: 'This version',
    verb: 'activating',
  },
};
